import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { DeleteRespondentRPC } from "./deleteRespondentRPC";

export class DeleteRespondentRPCClientImpl extends DeleteRespondentRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: DeleteRespondentRPC.Request): Promise<LeoRPCResult<DeleteRespondentRPC.Response, DeleteRespondentRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "respondent/DeleteRespondent",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      DeleteRespondentRPC.ResponseDTO,
      DeleteRespondentRPC.Errors.ErrorsDTO,
      DeleteRespondentRPC.Response,
      DeleteRespondentRPC.Errors.Errors
    >(
      response,
      "respondent/DeleteRespondent",
      DeleteRespondentRPC.Response.fromDTO,
      DeleteRespondentRPC.Errors.fromDTO
    );
  }
}
